// Vue
import { computed, ComputedRef } from 'vue'

// State
import {getAutocompleteState} from '../state/autocompleteState'

const domainsResults: ComputedRef<number> = computed(() => {
    const autocompleteState = getAutocompleteState()
    return autocompleteState.state.domains.length
})

export default domainsResults
